import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareListEmbedRoute: InvariantJiraRoute = {
	name: 'software-list-embed',
	path: '/jira/software/projects/:projectKey/list/embed',
};
